// extracted by mini-css-extract-plugin
export default {"addressSection":"YT-z","disabled":"ZT-z","sectionButtons":"_T-z","logo":"aU-z"};